module.exports = __webpack_public_path__ + "static/media/crossIcon.689f3637.svg";